import React from 'react';
import { motion } from 'framer-motion';
import { LeafIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20 px-4 sm:px-6 lg:px-8 bg-[radial-gradient(circle_at_center,rgba(253,248,240,1)_0%,rgba(245,235,220,1)_100%)]" data-id="element-28">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-29">
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 0.05
      }} transition={{
        duration: 2
      }} className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-gold blur-3xl" data-id="element-30" />
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 0.03
      }} transition={{
        duration: 2,
        delay: 0.5
      }} className="absolute -bottom-[20%] -left-[10%] w-[60%] h-[60%] rounded-full bg-sage blur-3xl" data-id="element-31" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-32">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col items-center" data-id="element-33">
          <div className="flex items-center justify-center space-x-3 mb-8" data-id="element-34">
            <div className="h-[1px] w-12 bg-gold" data-id="element-35"></div>
            <LeafIcon className="w-5 h-5 text-gold" aria-hidden="true" data-id="element-36" />
            <div className="h-[1px] w-12 bg-gold" data-id="element-37"></div>
          </div>

          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-serif font-medium text-charcoal leading-tight mb-8 tracking-tight" data-id="element-38">
            ¿Y si te dijera que 3 zonas específicas de tu hogar están bloqueando
            tu abundancia en este momento? Aquí está exactamente cómo
            desbloquearlas.
          </h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="text-lg sm:text-xl md:text-2xl text-sage max-w-3xl mx-auto leading-relaxed mb-12 font-light" data-id="element-39">
            Descubre los micro-ajustes de Feng Shui que transforman tu hogar en
            un imán de abundancia, descanso y bienestar en menos de 15 minutos.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="mb-12" data-id="element-40">
            <img src="https://cdn.magicpatterns.com/uploads/gfDJksRikw2ppbc3MrtuEt/el_codigo_oculto_de_tu_hogar_ebook.png" alt="El Código Oculto de Tu Hogar - Ebook" className="w-48 sm:w-56 md:w-64 mx-auto drop-shadow-2xl" data-id="element-41" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} data-id="element-42">
            <a href="#offer" className="inline-flex items-center justify-center px-8 py-4 text-base sm:text-lg font-medium text-cream bg-terracotta rounded-full shadow-warm hover:shadow-warm-lg hover:scale-[1.02] transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-terracotta focus:ring-offset-cream" aria-label="Desbloquea mi hogar ahora" data-id="element-43">
              DESBLOQUEA MI HOGAR AHORA
            </a>
          </motion.div>
        </motion.div>
      </div>

      {/* Bottom organic curve */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none" data-id="element-44">
        <svg className="relative block w-full h-[50px] sm:h-[100px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-45">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V95.8C59.71,118.08,130.83,116.8,201.39,109.4,242.41,105.1,283.4,91.8,321.39,56.44Z" fill="#ffffff" data-id="element-46"></path>
        </svg>
      </div>
    </section>;
}